import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "receipt-check"
}
const _hoisted_2 = {
  key: 0,
  class: "receipt-check__verdict"
}
const _hoisted_3 = ["disabled", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.chequeCheckerEnabled && (_ctx.verdict || _ctx.canCheck))
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        (_ctx.verdict)
          ? (_openBlock(), _createElementBlock("small", _hoisted_2, _toDisplayString(_ctx.verdict), 1))
          : _createCommentVNode("", true),
        (_ctx.canCheck)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "btn btn--2 receipt-check__btn",
              disabled: _ctx.pending,
              title: _ctx.checkedAtTitle,
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.check && _ctx.check(...args)), ["prevent"]))
            }, _toDisplayString(_ctx.$t('button.check_receipt')), 9, _hoisted_3))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}